import { account } from '@/services'
import { useState } from 'react'
import { useMutation } from 'react-query'
import Link from 'next/link'

import useContentGlobal from '@/hooks/useContentGlobal'

export const ForgotPassPage = () => {
  const [username, setUsername] = useState("")
  const [step, setStep] = useState(1)

  const { getValueByKey } = useContentGlobal();

  const { mutate, isLoading } = useMutation(async (username: string) => { await account.forgotPassword(username) }, {
    onSuccess: () => {
      setStep(2)
    },
  })
  return (
    <>
      {step === 1 && (<section className="forget-password update-pass ht">
        <div className="container">
          <div className="update-pass-wr txt-center mg-auto sec-heading">
            <h2 className="heading">{getValueByKey(["Account_page", "Change_Pass", "Title"])}</h2>
            <p className="desc">{getValueByKey(["Account_page", "Change_Pass", "Desc"])}</p>
            <div className="form-update">
              <form className="form" action="">
                <div className="form-list">
                  <div className="form-it">
                    {/* <label className="form-label">Tên tài khoản đăng nhập, hoặc tài khoản đăng nhập</label> */}
                    <div className="input">
                      <input className="form-control" type="email" placeholder="Email" id="mail" value={username} onChange={(e) => setUsername(e.target.value)} />
                    </div>
                  </div>
                  <div className="form-it" onClick={() => mutate(username)}><p className="btn btn-submit btn--pri" >{isLoading ? <i className="fa-regular fa-circle-notch fa-spin"></i> : getValueByKey(["Account_page", "Change_Pass", "Button"])}</p></div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>)}
      {step === 2 && (<section className="forget-pass-success ht">
        <div className="container">
          <div className="forget-pass-wr txt-center">
            <div className="heading">
              <h2>{getValueByKey(["Account_page", "Change_Pass", "Success", "Title"])}</h2>
            </div>
            <div className="content">
              <p>{getValueByKey(["Account_page", "Change_Pass", "Success", "Desc"])}</p>
            </div>
            <div className="btn btn--pri mg-auto">
              <Link href={"/login"}>{getValueByKey(["Account_page", "Change_Pass", "Success", "Button"])}</Link></div>
          </div>
        </div>
      </section>)}

    </>
  )
}